var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdventuresSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "112px",
    viewBox: "0 0 91 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(0.586418, 0.658574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8021373,2.44437774 C66.3682915,2.44206125 72.5037494,8.57376329 72.5060658,16.1399176 C72.5060667,16.1427128 72.5060667,16.145508 72.5060658,16.1483033 L72.4818107,95.428462 C72.479494,103.000606 66.3416382,109.138463 58.7694943,109.140781 C51.20334,109.143098 45.0678822,103.011396 45.0655657,95.4452416 C45.0655649,95.4424464 45.0655649,95.4396511 45.0655657,95.4368559 L45.0898209,16.1566972 C45.0921375,8.58455324 51.2299934,2.44669606 58.8021373,2.44437774 Z",
    id: "Rectangle-Copy-3",
    fill: "#00C853",
    transform: "translate(58.785816, 55.792580) rotate(-20.000000) translate(-58.785816, -55.792580) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3566568,1.83488523 C38.9288007,1.83720356 45.0666566,7.97506074 45.0689732,15.5472047 L45.0932284,94.8275999 C45.0955432,102.393754 38.9638397,108.529211 31.3976855,108.531525 C31.3948902,108.531526 31.392095,108.531526 31.3892998,108.531525 C23.8171559,108.529207 17.6793,102.39135 17.6769834,94.819206 L17.6527282,15.5388107 C17.6504134,7.97265647 23.7821168,1.83720003 31.3482711,1.83488523 C31.3510664,1.83488437 31.3538616,1.83488437 31.3566568,1.83488523 Z",
    id: "Rectangle",
    fill: "#00B0FF",
    transform: "translate(31.372978, 55.183205) rotate(20.000000) translate(-31.372978, -55.183205) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdventuresSmall);
export default __webpack_public_path__ + "static/media/adventures___small.ebc3ab90b505b25476ed29b8fd18186f.svg";
export { ForwardRef as ReactComponent };